export const BASE_CND = 'https://s1.pclncdn.com';
export const IMPLEMENTATION_ENDPOINTS = {
  DRIVE: '/genai-svc/genai/chat/st/rcListings',
  STAYDETAILS: '/genai-svc/genai/chat/st/hotelDetail',
  STAYLISTINGS: '/genai-svc/genai/chat/st/hotelListings',
  FLY: '/genai-svc/genai/chat/st/flight',
  PACKAGE: '/genai-svc/genai/chat/st/package',
  ITINERARY: '/genai-svc/genai/chat/st/travelItinerary',
  LANDING: '/genai-svc/genai/chat/st/homePageSearch?useHTLURL=true',
  CHECKOUT: '/genai-svc/genai/chat/st/cart',
  PORTAL: '/genai-svc/genai/chat/pennyPortal?useHTLURL=true'
};